<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Along UNESCO Bay - Kotor and its surroundings</h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour3/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              This day is reserved for real gems of Montenegrin coast, the
              pearls of Venetian architecture, the area governed by Venetian
              Republic for a few centuries but also by Austro Hungarian Monarchy
              for quite some time. Owing to its cultural value and the way it
              melts with the landscape it is listed as UNESCO world cultural
              heritage site.
            </p>
            <p class='pasus'>
              After an hour of enjoyable drive we arrive at the lookout with a
              nice view on Adriatic Sea coast, to reach the old town of Kotor in
              an additional 30 minutes. We take a walk down its narrow streets,
              take a glimpse into its hidden corners, pay a visit to old
              churches and cathedrals and if you wish so, walk the old town
              walls protected by UNESCO as the town itself.
            </p>
            <p class='pasus'>
              The route takes us further to the magical baroque town of Perast,
              famous for its maritime history, festivals and numerous legends.
              We will enjoy the short boat ride to one of the two islands with
              catholic churches built on them – Our Lady of the Rocks, where
              along with artistically high-range icon making there is a museum
              testifying about the history of the sanctuary and the
              surroundings.
            </p>
            <p class='pasus'>
              We then continue our ride down the part of the bay protected by
              UNESCO and through the old coastal settlements.
            </p>
            <p class='pasus'>
              You will have the opportunity to enjoy fish delicacies in some of
              the taverns on the sea shore or in the old town of Kotor and to
              taste the famous Kotor cream pie.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Availability: April – November</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>
              Departure from: Podgorica/ for departures from other cities, the
              price can be obtained upon request
            </p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 10 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                9 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After an hour of drive we arrive at the famous lookout with an
                impressive view on the Adriatic Sea coast.
              </li>
              <li class='pasus'>
                We continue further and in 45 minutes we arrive at Kotor. The
                next 2 to 3 hours we will spend discovering the beauties of old
                town.
              </li>
              <li class='pasus'>
                The route then takes us to baroque settlement of Perast where we
                take a short boat ride to Our Lady of the Rocks Island to visit
                the famous sanctuary and a museum within it.
              </li>
              <li class='pasus'>
                Perast is an ideal place to have lunch in after which we
                continue down the coast of Kotor-Risan bay which is completely
                protected by UNESCO.
              </li>
              <li class='pasus'>
                We go through a couple of old settlements, enjoy the view on
                gulf’s beauties from different angles and hear some local
                legends.
              </li>
              <li class='pasus'>
                On our way back to Podgorica, if you wish so and if we have
                enough time, we won’t miss to take a panoramic drive along Budva
                Riviera.
              </li>
              <li class='pasus'>We are back in Podgorica by late afternoon.</li>
            </ul>
            <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 3.5 hours</p>
              <p> <i class='fas fa-route'></i> 210 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 220 EUR</li>
              <li class='pasus'>2 persons – 125 EUR p/person</li>
              <li class='pasus'>3 persons – 90 EUR p/person</li>
              <li class='pasus'>4 persons – 70 EUR p/person</li>
              <li class='pasus'>5 persons - 100 EUR p/person</li>
              <li class='pasus'>6 persons – 90 EUR p/person</li>
              <li class='pasus'>7 persons – 75 EUR p/person</li>
              <li class='pasus'></li>
              <li class='pasus'>
                For larger groups the price can be obtained upon request.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>Tourist tax - Kotor</li>
              <li class='pasus'>
                Entrance fees for 2 museums, Kotor’s Cathedral
              </li>
              <li class='pasus'>Boat drive to Our Lady of the Rocks Island</li>
              <li class='pasus'>Professional guiding service - English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a cap and sunglasses.
              </li>
              <li class='pasus'>
                We recommend purchasing authentic local souvenirs and products.
              </li>
              <li class='pasus'>
                Prices of food and beverage in local restaurants are affordable.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>
                Itinerary changes during the tour as agreed (do not affect the
                price)
              </li>
              <li class='pasus'>Lunch at local restaurant (15-20 EUR)</li>
              <li class='pasus'>
                The entrance to and walk the Kotor walls (ticket = 8 EUR)
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour3/01.jpg'),
          thumbnail: require('@/assets/cultours/tour3/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/02.jpg'),
          thumbnail: require('@/assets/cultours/tour3/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/03.jpg'),
          thumbnail: require('@/assets/cultours/tour3/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/04.jpg'),
          thumbnail: require('@/assets/cultours/tour3/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/05.jpg'),
          thumbnail: require('@/assets/cultours/tour3/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/06.jpg'),
          thumbnail: require('@/assets/cultours/tour3/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/07.jpg'),
          thumbnail: require('@/assets/cultours/tour3/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/08.jpg'),
          thumbnail: require('@/assets/cultours/tour3/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/09.jpg'),
          thumbnail: require('@/assets/cultours/tour3/09.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/10.jpg'),
          thumbnail: require('@/assets/cultours/tour3/10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour3/11.jpg'),
          thumbnail: require('@/assets/cultours/tour3/11.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT3_Kotor.vue